export default __webpack_public_path__ + "static/media/loader.04e124a9.gif";